(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })((sectionRoot) => {
  document.querySelectorAll('[data-ae-announcements]').forEach((bar) => {
    if (bar.dataset.aeBound === 'true') return;
    bar.dataset.aeBound = 'true';
    const container = bar.querySelector('[data-ae-announcement-container]');
    const items = Array.from(bar.querySelectorAll('[data-ae-announcement-item]'));
    const prev = bar.querySelector('[data-ae-announcement-prev]');
    const next = bar.querySelector('[data-ae-announcement-next]');
    if (!container || !items.length) return;

    let index = 0;

    const showItem = (newIndex) => {
      const total = items.length;
      const safeIndex = ((newIndex % total) + total) % total;
      container.style.transform = `translateX(-${safeIndex * 100}%)`;
      items.forEach((item, i) => item.classList.toggle('is-active', i === safeIndex));
      index = safeIndex;
    };

    items.forEach((item) => item.removeAttribute('hidden'));
    showItem(0);

    prev?.addEventListener('click', () => {
      stopAutoplay();
      showItem(index - 1);
      startAutoplay();
    });
    next?.addEventListener('click', () => {
      stopAutoplay();
      showItem(index + 1);
      startAutoplay();
    });

    const autoplayEnabled = bar.dataset.autoplay !== 'false' && items.length > 1;
    const autoplayInterval = Math.max(1000, parseInt(bar.dataset.autoplayInterval, 10) || 2000);
    let timer = null;

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      timer = window.setInterval(() => {
        showItem((index + 1) % items.length);
      }, autoplayInterval);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (autoplayEnabled) {
      bar.addEventListener('mouseenter', stopAutoplay);
      bar.addEventListener('mouseleave', startAutoplay);
      bar.addEventListener('focusin', stopAutoplay);
      bar.addEventListener('focusout', startAutoplay);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });
      startAutoplay();
    }
  });

  document.querySelectorAll('[data-ae-header]').forEach((header) => {
    const desktopBreakpoint = 990;
    const hoverDelayMs = 90;
    const mobileToggle = header.querySelector('[data-ae-mobile-toggle]');
    const mobilePanel = header.querySelector('[data-ae-mobile-panel]');
    const desktopOverlay = header.querySelector('[data-ae-header-desktop-overlay]');
    const mobileOverlay = header.querySelector('[data-ae-header-mobile-overlay]');
    const menuItems = Array.from(header.querySelectorAll('[data-ae-menu-item]'));
    let closeTimer = null;
    let activeItem = null;

    const isDesktopViewport = () => window.innerWidth >= desktopBreakpoint;

    const clearCloseTimer = () => {
      if (!closeTimer) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    const setDesktopOverlay = (active) => {
      if (!desktopOverlay) return;
      desktopOverlay.hidden = !active;
      desktopOverlay.classList.toggle('is-active', active);
      desktopOverlay.setAttribute('aria-hidden', String(!active));
    };

    const setMobilePanelState = (open) => {
      if (!mobileToggle || !mobilePanel) return;
      mobileToggle.setAttribute('aria-expanded', String(open));
      mobilePanel.hidden = !open;
      mobilePanel.setAttribute('aria-hidden', String(!open));
      mobileOverlay?.toggleAttribute('hidden', !open);
    };

    const activateRichTabs = (scope) => {
      const buttons = Array.from(scope.querySelectorAll('[data-ae-rich-tab-button]'));
      const views = Array.from(scope.querySelectorAll('[data-ae-rich-tab-view]'));
      if (!buttons.length || !views.length) return;

      const setActive = (button) => {
        const targetId = button.dataset.aeRichTarget;
        buttons.forEach((btn) => {
          const active = btn === button;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', String(active));
          btn.setAttribute('tabindex', active ? '0' : '-1');
        });
        views.forEach((view) => {
          view.hidden = view.id !== targetId;
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => setActive(button));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const currentIndex = buttons.indexOf(button);
          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = buttons.length - 1;
          buttons[nextIndex].focus();
          setActive(buttons[nextIndex]);
        });
      });
    };

    const closeMenus = (except = null) => {
      clearCloseTimer();
      menuItems.forEach((item) => {
        if (except && item === except) return;
        item.classList.remove('is-open');
        item.setAttribute('data-open', 'false');
        const toggle = item.querySelector('[data-ae-menu-toggle]');
        const panel = item.querySelector('[data-ae-menu-panel]');
        toggle?.setAttribute('aria-expanded', 'false');
        panel?.setAttribute('aria-hidden', 'true');
      });
      activeItem = except;
      if (!except) setDesktopOverlay(false);
    };

    const openItem = (item) => {
      const toggle = item.querySelector('[data-ae-menu-toggle]');
      const panel = item.querySelector('[data-ae-menu-panel]');
      if (!toggle || !panel) return;
      clearCloseTimer();
      closeMenus(item);
      item.classList.add('is-open');
      item.setAttribute('data-open', 'true');
      toggle.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('hidden');
      panel.setAttribute('aria-hidden', 'false');
      activeItem = item;
      if (isDesktopViewport()) setDesktopOverlay(true);
    };

    const scheduleClose = (item = null) => {
      clearCloseTimer();
      closeTimer = window.setTimeout(() => {
        if (item && item.matches(':hover')) return;
        if (desktopOverlay?.matches(':hover')) return;
        closeMenus();
      }, hoverDelayMs);
    };

    menuItems.forEach((item) => {
      const toggle = item.querySelector('[data-ae-menu-toggle]');
      const panel = item.querySelector('[data-ae-menu-panel]');
      if (!toggle || !panel) return;

      activateRichTabs(panel);

      toggle.addEventListener('click', (event) => {
        const isDesktop = isDesktopViewport();
        const isOpen = item.classList.contains('is-open');
        if (isDesktop) event.preventDefault();
        if (isOpen) {
          closeMenus();
          return;
        }
        openItem(item);
      });

      item.addEventListener('mouseenter', () => {
        if (!isDesktopViewport()) return;
        openItem(item);
      });

      item.addEventListener('mouseleave', () => {
        if (!isDesktopViewport()) return;
        scheduleClose(item);
      });

      panel.addEventListener('mouseenter', clearCloseTimer);
      panel.addEventListener('mouseleave', () => {
        if (!isDesktopViewport()) return;
        scheduleClose(item);
      });

      item.addEventListener('focusout', (event) => {
        if (!isDesktopViewport()) return;
        if (item.contains(event.relatedTarget)) return;
        window.setTimeout(() => {
          if (!item.contains(document.activeElement)) {
            item.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            panel.setAttribute('aria-hidden', 'true');
            panel.hidden = true;
            if (activeItem === item) {
              activeItem = null;
              setDesktopOverlay(false);
            }
          }
        }, 0);
      });
    });

    desktopOverlay?.addEventListener('mouseenter', clearCloseTimer);
    desktopOverlay?.addEventListener('click', () => closeMenus());

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeMenus();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const previouslyOpen = activeItem;
        closeMenus();
        setMobilePanelState(false);
        if (previouslyOpen) {
          const toggle = previouslyOpen.querySelector('[data-ae-menu-toggle]');
          toggle?.focus({ preventScroll: true });
        } else if (mobileToggle && mobileToggle.getAttribute('aria-expanded') === 'true') {
          mobileToggle.focus({ preventScroll: true });
        }
      }
    });

    const mobileGroups = Array.from(header.querySelectorAll('[data-ae-mobile-group]'));
    mobileGroups.forEach((group) => {
      const toggle = group.querySelector('[data-ae-mobile-group-toggle]');
      const panel = group.querySelector('[data-ae-mobile-group-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      });
    });

    const mobileTabs = header.querySelector('[data-ae-mobile-tabs]');
    if (mobileTabs) {
      const tabButtons = Array.from(mobileTabs.querySelectorAll('[data-ae-mobile-tab]'));
      const views = Array.from(header.querySelectorAll('[data-ae-mobile-view]'));
      tabButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const target = btn.getAttribute('data-ae-mobile-tab');
          mobileTabs.setAttribute('data-active-tab', target);
          tabButtons.forEach((b) => {
            const isActive = b === btn;
            b.classList.toggle('is-active', isActive);
            b.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          views.forEach((view) => {
            const isMatch = view.getAttribute('data-ae-mobile-view') === target;
            view.classList.toggle('is-active', isMatch);
            view.hidden = !isMatch;
          });
        });
      });
    }

    if (mobileToggle && mobilePanel) {
      mobileToggle.addEventListener('click', () => {
        const expanded = mobileToggle.getAttribute('aria-expanded') === 'true';
        setMobilePanelState(!expanded);
        if (!expanded) closeMenus();
      });

      mobileOverlay?.addEventListener('click', () => setMobilePanelState(false));

      const mobileCloseBtn = mobilePanel.querySelector('[data-ae-mobile-close]');
      mobileCloseBtn?.addEventListener('click', () => setMobilePanelState(false));

      const getFocusable = (root) => Array.from(root.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((el) => el.offsetParent !== null || el === document.activeElement);

      const handleMobileFocusTrap = (event) => {
        if (event.key !== 'Tab') return;
        if (mobilePanel.hidden) return;
        const activeView = mobilePanel.querySelector('[data-ae-mobile-branch]:not([hidden]).is-active')
          || mobilePanel.querySelector('[data-ae-mobile-root]')
          || mobilePanel;
        const focusable = [
          ...getFocusable(mobilePanel.querySelector('.ae-mobile-panel__head') || mobilePanel),
          ...getFocusable(activeView)
        ];
        if (focusable.length === 0) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus({ preventScroll: true });
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus({ preventScroll: true });
        }
      };
      document.addEventListener('keydown', handleMobileFocusTrap);

      const branchView = mobilePanel.querySelector('[data-ae-mobile-branch]');
      const branchTitle = mobilePanel.querySelector('[data-ae-mobile-branch-title]');
      const branchList = mobilePanel.querySelector('[data-ae-mobile-branch-list]');
      const backBtn = mobilePanel.querySelector('[data-ae-mobile-back]');
      const drillButtons = Array.from(mobilePanel.querySelectorAll('[data-ae-mobile-drill]'));

      const closeDrill = () => {
        if (!branchView) return;
        mobilePanel.classList.remove('is-drilled');
        branchView.classList.remove('is-active');
        window.setTimeout(() => {
          if (!branchView.classList.contains('is-active')) {
            branchView.hidden = true;
            if (branchList) branchList.innerHTML = '';
          }
        }, 320);
      };

      const openDrill = (drillKey, label) => {
        if (!branchView || !branchList) return;
        const tpl = mobilePanel.querySelector(`template[data-ae-mobile-drill-template="${drillKey}"]`);
        if (!tpl) return;
        branchList.innerHTML = '';
        branchList.appendChild(tpl.content.cloneNode(true));
        if (branchTitle) branchTitle.textContent = label || '';
        branchView.hidden = false;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            mobilePanel.classList.add('is-drilled');
            branchView.classList.add('is-active');
            backBtn?.focus({ preventScroll: true });
          });
        });
      };

      drillButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const key = btn.getAttribute('data-ae-mobile-drill');
          const label = btn.getAttribute('data-ae-mobile-drill-label') || btn.textContent.trim();
          openDrill(key, label);
        });
      });

      const branchJumpButtons = Array.from(mobilePanel.querySelectorAll('[data-ae-mobile-branch-jump]'));
      branchJumpButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const target = btn.getAttribute('data-ae-mobile-branch-jump');
          const rootTabBtn = mobilePanel.querySelector(`[data-ae-mobile-tab="${target}"]`);
          if (rootTabBtn) rootTabBtn.click();
          closeDrill();
        });
      });

      backBtn?.addEventListener('click', closeDrill);

      const originalSetMobilePanelState = setMobilePanelState;
      mobilePanel.addEventListener('transitionend', () => {
        if (mobilePanel.hidden) closeDrill();
      });
    }

    window.addEventListener('resize', () => {
      if (!isDesktopViewport()) {
        closeMenus();
        return;
      }
      setMobilePanelState(false);
      if (activeItem?.classList.contains('is-open')) {
        setDesktopOverlay(true);
      }
    });

    const announcementBar = header.querySelector('.ae-announcement-bar');
    const updateStickyTopVar = () => {
      const announceHeight = announcementBar ? announcementBar.offsetHeight : 0;
      const headerHeight = header.querySelector('.ae-header__inner')?.offsetHeight || 0;
      document.documentElement.style.setProperty('--ae-header-sticky-top', `${announceHeight + headerHeight}px`);
      document.documentElement.style.setProperty('--ae-header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--ae-announcement-height', `${announceHeight}px`);
    };
    updateStickyTopVar();
    window.addEventListener('resize', updateStickyTopVar);
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(updateStickyTopVar);
      ro.observe(header);
      if (announcementBar) ro.observe(announcementBar);
    }
  });
});
